"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Carousel = _interopRequireDefault(require("../Carousel/Carousel.utils"));

var _Gallery = require("../Gallery.types");

var _Thumbnail = _interopRequireDefault(require("./Thumbnail.index"));

var _Thumbnails = require("./Thumbnails.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Thumbnails = function Thumbnails(_ref) {
  var images = _ref.images,
      videos = _ref.videos,
      mode = _ref.mode,
      activeIndex = _ref.activeIndex,
      theme = _ref.theme,
      onThumbnailClick = _ref.onThumbnailClick,
      onThumbnailHover = _ref.onThumbnailHover,
      limit = _ref.limit;

  var _ref2 = theme !== null && theme !== void 0 ? theme : {},
      _ref2$gallery = _ref2.gallery;

  _ref2$gallery = _ref2$gallery === void 0 ? {} : _ref2$gallery;
  var _ref2$gallery$thumbna = _ref2$gallery.thumbnail;
  _ref2$gallery$thumbna = _ref2$gallery$thumbna === void 0 ? {} : _ref2$gallery$thumbna;
  var _ref2$gallery$thumbna2 = _ref2$gallery$thumbna.max,
      max = _ref2$gallery$thumbna2 === void 0 ? 6 : _ref2$gallery$thumbna2,
      sizePref = _ref2$gallery$thumbna.sizePref,
      _ref2$gallery$thumbna3 = _ref2$gallery$thumbna.scrollSelected,
      scrollSelected = _ref2$gallery$thumbna3 === void 0 ? false : _ref2$gallery$thumbna3,
      _ref2$gallery$thumbna4 = _ref2$gallery$thumbna.rowWidth,
      rowWidth = _ref2$gallery$thumbna4 === void 0 ? 2 : _ref2$gallery$thumbna4,
      _ref2$gallery$thumbna5 = _ref2$gallery$thumbna.remaining;
  _ref2$gallery$thumbna5 = _ref2$gallery$thumbna5 === void 0 ? {} : _ref2$gallery$thumbna5;
  var _ref2$gallery$thumbna6 = _ref2$gallery$thumbna5.show,
      show = _ref2$gallery$thumbna6 === void 0 ? true : _ref2$gallery$thumbna6,
      _ref2$gallery$thumbna7 = _ref2$gallery$thumbna.video;
  _ref2$gallery$thumbna7 = _ref2$gallery$thumbna7 === void 0 ? {} : _ref2$gallery$thumbna7;
  var videoStyle = _ref2$gallery$thumbna7.style;
  var media = [];

  switch (mode) {
    case 'VIDEO':
      media = videos;
      break;

    case 'IMAGE':
      media = images;
      break;

    case 'MIXED':
    default:
      media = [].concat((0, _toConsumableArray2["default"])(images), (0, _toConsumableArray2["default"])(videos));
      break;
  }

  var list = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (scrollSelected) {
      var _list$current;

      var _ref3 = (_list$current = list.current) !== null && _list$current !== void 0 ? _list$current : {},
          scrollHeight = _ref3.scrollHeight,
          clientHeight = _ref3.clientHeight;

      var rows = Math.ceil(media.length / rowWidth);
      var pageHeight = scrollHeight / rows;
      (0, _Carousel["default"])(list.current, pageHeight * (activeIndex - 1) - clientHeight / 2);
    }
  }, [activeIndex]);
  return /*#__PURE__*/_react["default"].createElement(_Thumbnails.ThumbnailList, {
    theme: theme,
    ref: list
  }, media.map(function (image, index) {
    if (max > 0 && index >= max && mode !== 'VIDEO' && limit) {
      return null;
    }

    var showRemaining = max > 0 && media.length > max && show && mode !== 'VIDEO' && limit;
    var remaining = showRemaining && index === max - 1 ? media.length - (max - 1) : -1;
    var showVideoOverlay = videoStyle === 'Overlay' && mode === 'MIXED' && limit && (index === max - 1 && !showRemaining || showRemaining && index === max - 2);
    var command = remaining > 0 && 'IMAGE' || showVideoOverlay && 'VIDEO';
    var src = sizePref && image.sizes && image.sizes[sizePref] ? image.sizes[sizePref] : image.thumbnail;
    return /*#__PURE__*/_react["default"].createElement(_Thumbnails.ThumbnailWrapper, {
      key: image.thumbnail && image.thumbnail !== 'data:;' ? "".concat(image.thumbnail, "-").concat(index) : index,
      theme: theme
    }, /*#__PURE__*/_react["default"].createElement(_Thumbnail["default"], {
      src: src,
      description: image.description,
      mediaType: showVideoOverlay ? 'VIDEO' : image.type,
      selected: index === activeIndex,
      remaining: remaining,
      onClick: function onClick() {
        return onThumbnailClick(index, image, command);
      },
      onMouseEnter: function onMouseEnter() {
        return !command && onThumbnailHover(index, image);
      },
      theme: theme
    }));
  }).filter(function (i) {
    return i;
  }), videoStyle === 'Link' && mode === 'IMAGE' && /*#__PURE__*/_react["default"].createElement("p", null, "Video Link"));
};

Thumbnails.propTypes = {
  onThumbnailClick: _propTypes["default"].func.isRequired,
  onThumbnailHover: _propTypes["default"].func.isRequired,
  mode: _propTypes["default"].oneOf(['VIDEO', 'IMAGE', 'MIXED']).isRequired,
  theme: _Gallery.galleryTheme,
  limit: _propTypes["default"].bool,
  images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    thumbnail: _propTypes["default"].string,
    type: _propTypes["default"].oneOf(['VIDEO', 'IMAGE'])
  })),
  videos: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    thumbnail: _propTypes["default"].string,
    type: _propTypes["default"].oneOf(['VIDEO', 'IMAGE'])
  })),
  activeIndex: _propTypes["default"].number.isRequired
};
Thumbnails.defaultProps = {
  images: [],
  videos: [],
  limit: true,
  theme: undefined
};
Thumbnails.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Thumbnails",
  "props": {
    "images": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "thumbnail": {
              "name": "string",
              "required": false
            },
            "type": {
              "name": "enum",
              "value": [{
                "value": "'VIDEO'",
                "computed": false
              }, {
                "value": "'IMAGE'",
                "computed": false
              }],
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "videos": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "thumbnail": {
              "name": "string",
              "required": false
            },
            "type": {
              "name": "enum",
              "value": [{
                "value": "'VIDEO'",
                "computed": false
              }, {
                "value": "'IMAGE'",
                "computed": false
              }],
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "limit": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "theme": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "galleryTheme"
      },
      "required": false
    },
    "onThumbnailClick": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onThumbnailHover": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "mode": {
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'VIDEO'",
          "computed": false
        }, {
          "value": "'IMAGE'",
          "computed": false
        }, {
          "value": "'MIXED'",
          "computed": false
        }]
      },
      "required": true
    },
    "activeIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Thumbnails);

exports["default"] = _default;